// Animate On Scroll
// import AOS from "aos"
// AOS.init()

// Menu
import menu from "./modules/menu";
menu();

// Filters
import filters from "./modules/filters";
filters();

// Fitvids - make embedded videos fill space
import fitvids from "fitvids";
fitvids("[data-video]");

// Accordion
import accordion from "./modules/accordion";
accordion();

// Accordion
import tabs from "./modules/tabs";
tabs();

// Values Grid
import valuesGrid from "./modules/values-grid";
valuesGrid();

// Team Grid
import teamGrid from "./modules/team-grid";
teamGrid();

import Glide from "@glidejs/glide";
window.setTimeout(() => {
	if (document.querySelector(".glide") !== null) {
		new Glide(".glide", {
			gap: 40,
		}).mount();
	}
}, 1000);

// Forms
import forms from "./modules/forms";
forms();

import scroll from './modules/scroll';
scroll();

import progressiveNavigation from './modules/progressive-navigation';
progressiveNavigation();

import tables from './modules/tables';
tables();
